/* Image guard (Zach, 2026-09-28). A deterrent, not a lock: nothing can stop a screenshot.
   1. No right-click menu, dragging or long-press "Save image" on photos (see also the CSS in century.css).
   2. Hides the "search by image" buttons that the AliPrice / AiPrice browser extension adds on top of photos. Its
      class names aren't published, so anything added to the page whose tag, id, class or image source mentions
      aliprice / aiprice is hidden as soon as it appears. */
(() => {
  const isPhoto = (target) =>
    target instanceof Element && (target.closest('img, picture, video, svg image') !== null || target.matches('img'));

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (isPhoto(event.target)) event.preventDefault();
    },
    true
  );
  document.addEventListener(
    'dragstart',
    (event) => {
      if (isPhoto(event.target)) event.preventDefault();
    },
    true
  );

  const pattern = /ali-?price|ai-?price/i;
  const looksInjected = (node) => {
    if (!(node instanceof Element)) return false;
    const className = typeof node.className === 'string' ? node.className : node.getAttribute('class') || '';
    return (
      pattern.test(node.tagName) ||
      pattern.test(node.id || '') ||
      pattern.test(className) ||
      pattern.test(node.getAttribute('src') || '') ||
      pattern.test(node.getAttribute('href') || '')
    );
  };
  const hide = (node) => {
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('pointer-events', 'none', 'important');
  };
  const scan = (root) => {
    if (looksInjected(root)) {
      hide(root);
      return;
    }
    if (!(root instanceof Element) || !root.querySelectorAll) return;
    root.querySelectorAll('[id], [class], [src], [href]').forEach((node) => {
      if (looksInjected(node)) hide(node);
    });
  };

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        // Only elements the extension could have added: our own markup never mentions AliPrice.
        if (node instanceof Element) scan(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document.documentElement);
})();
